export default "__VITE_ASSET__BS5jbaV2__"